import { render, staticRenderFns } from "./CreateLabel.vue?vue&type=template&id=6aab9518&"
import script from "./CreateLabel.vue?vue&type=script&lang=js&"
export * from "./CreateLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports